import React from 'react';
import Loading from '~/Components/Loading';
import GridLanctoAdm from './GridLanctoAdm';
import GridTransfComissao from './GridTransfComissao';
import GridRetencao from './GridRetencao';

const TabContabil = ({ codigoFamilia, dados, permissoes, onRecarregar }) => {
  if (dados == null) return <Loading />;

  return (
    <div>
      <GridLanctoAdm
        codigoFamilia={codigoFamilia}
        lancamentos={dados.lancamentos != null ? dados.lancamentos : []}
        permissoes={permissoes}
        onRecarregar={onRecarregar}
      />
      {permissoes.transfere_comissao && (
        <GridTransfComissao
          codigoFamilia={codigoFamilia}
          transferencias={dados.transferencias != null ? dados.transferencias : []}
          onRecarregar={onRecarregar}
        />
      )}
      <GridRetencao
        codigoFamilia={codigoFamilia}
        retencoes={dados.retencoes != null ? dados.retencoes : []}
        onRecarregar={onRecarregar}
      />
    </div>
  );
};

export default TabContabil;
